import React from 'react'
import { VerifyContract, PromotionalFooterPure  } from '../../pures'
import { Container, Grid, useMediaQuery } from '@material-ui/core'

const VerifyContractView = (props) => {
  const gridInformationContactPlanStyles = {
    alignItems: 'start',
    justifyContent: 'space-between',
  }
  const longmatches = useMediaQuery('(max-width:1200px)')

  const globalContainerStyles = {
    backgroundColor: 'white',
    marginLeft: '5px',
    maxWidth: '100%',
    boxShadow: '1px 1px 3px #959595',
    marginRight: '105px',
    width: 'auto'
  }
  if (longmatches) {
    globalContainerStyles.marginRight = 0
  }

  return (
    <Container xs={12} lg={12} md={12} sm={12} es={12} style={globalContainerStyles}  >
      <VerifyContract />
      <PromotionalFooterPure />
    </Container>
  )
}

export { VerifyContractView as default }
